import { render, staticRenderFns } from "./bindECS.vue?vue&type=template&id=799e51a2&scoped=true&"
import script from "./bindECS.vue?vue&type=script&lang=js&"
export * from "./bindECS.vue?vue&type=script&lang=js&"
import style0 from "./bindECS.vue?vue&type=style&index=0&id=799e51a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e51a2",
  null
  
)

export default component.exports